import { Component, OnInit } from '@angular/core';
import { RegService } from '../../shared/Reg.Service';
import { AppInsightsService } from '../../shared/AppInsights.Service';

@Component({
  selector: 'app-step-three',
  templateUrl: './step-three.component.html',
  styleUrls: ['./step-three.component.scss']
})
export class StepThreeComponent implements OnInit {
  public email = '';
  public name = '';
  public address = '';
  public resp: any;
  public url = '';
  public claims = false;
  constructor(private regService: RegService, private appInsightsService: AppInsightsService) { }

  ngOnInit() {
  	window.scroll(0, 0);
  	this.appInsightsService.logEvent("Employee Registration UI Step Three");
    this.regService.loadData().subscribe(res => {
      this.resp = res;
      if (this.resp) {
        if (this.resp.status_code !== '200') {
			
        } else {			
		  if(this.resp.ebClaims === 'Y')
		  	this.claims = true;
          this.email = this.resp.newEmail;
          this.name = this.resp.name;
          this.address = this.resp.address;
          console.log('url ' + this.resp.url);
          this.url = this.resp.url;
        }
      }
    });

  }

  complete() {
    window.location.href = window.location.origin + this.url;
  }
}
